<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个{{this.route.menuName}}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">
            删除
          </el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column fixed :reserve-selection="true" type="selection" width="55" align="center"></el-table-column>
        <el-table-column fixed prop="no" label="医保代码">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="firstCategory" label="一级分类"></el-table-column>
        <el-table-column prop="secondCategory" label="二级分类"></el-table-column>
        <el-table-column prop="thirdCategory" label="三级分类"></el-table-column>
        <el-table-column prop="createdTime" label="创建时间">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column prop="operation" fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + '医保分类'" :visible.sync="open" :center="true" width="1100px" :before-close="cancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item prop="no" label="医保代码">
                <el-input :disabled="!editMode" v-model="form.no" placeholder="请输入医保代码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="firstCategory" label="一级分类">
                <el-input :disabled="!editMode" v-model="form.firstCategory" placeholder="请输入一级分类"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="secondCategory" label="二级分类">
                <el-input :disabled="!editMode" v-model="form.secondCategory" placeholder="请输入二级分类"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="thirdCategory" label="三级分类">
                <el-input :disabled="!editMode" v-model="form.thirdCategory" placeholder="请输入三级分类"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="commonName" label="医保通用名">
                <el-input :disabled="!editMode" v-model="form.commonName" placeholder="请输入医保通用名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="texture" label="材质">
                <el-input :disabled="!editMode" v-model="form.texture" placeholder="请输入材质"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="properties" label="特征">
                <el-input :disabled="!editMode" v-model="form.properties" placeholder="请输入特性"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input :disabled="!editMode" v-model="form.productRegistCertNo" placeholder="请输入注册证号"></el-input>
                <!-- <el-select v-model="form.productRegistCertNo" :disabled="isDisabled" filterable :filter-method="getProductRegistCerts" @change="certChange" placeholder="请选择注册证号">
                <el-option v-for="item in STATIC_ProductRegistCerts" :key="item.id" :label="item.no" :value="item.id"></el-option>
              </el-select> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input :disabled="!editMode" v-model="form.manufacturerName" placeholder="请输入生产厂家"></el-input>
                <!-- <el-select v-model="form.manufacturerName" :disabled="isDisabled" filterable :filter-method="getManufacturers" @change="manufacturerChange" placeholder="请选择生产厂家">
                <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="productName" label="单件产品名称">
                <el-input :disabled="!editMode" v-model="form.productName" placeholder="请输入单件产品名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="province" label="所属省份">
                <el-input :disabled="!editMode" v-model="form.province" placeholder="请输入所属省份"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <my-button class="btn primary" v-if="editMode" type="primary" size="small" v-preventReClick @click="submit">确 定</my-button>
        </div>
      </el-dialog>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  SaveMedicalInsuranceCategory,
  GetMedicalInsuranceCategoryById,
  GetMedicalInsuranceCategorys,
  RemoveMedicalInsuranceCategory
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";

export default {
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      title: "",
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        no: [
          { required: true, message: '请输入医保代码', trigger: 'blur' }
        ],
        firstCategory: [
          { required: true, message: '请输入一级分类', trigger: 'blur' }
        ],
        secondCategory: [
          { required: true, message: '请输入二级分类', trigger: 'blur' }
        ],
        thirdCategory: [
          { required: true, message: '请输入三级分类', trigger: 'blur' }
        ],
        commonName: [
          { required: true, message: '请输入医保通用名', trigger: 'blur' }
        ],
        texture: [
          { required: true, message: '请输入材质', trigger: 'blur' }
        ],
        properties: [
          { required: true, message: '请输入特性', trigger: 'blur' }
        ],
        productRegistCertNo: [
          { required: true, message: '请选择注册证号', trigger: 'blur' }
        ],
        manufacturerName: [
          { required: true, message: '请输入生产厂家', trigger: 'blur' }
        ],
        productName: [
          { required: true, message: '请输入单件产品名称', trigger: 'blur' }
        ]
      },
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;
    },
    // 获取列表
    getData () {
      GetMedicalInsuranceCategorys(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    handleInfo (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.open = true;
      this.title = "编辑";
      this.editMode = true;
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveMedicalInsuranceCategory(this.form)
          .then((res) => {
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally(() => {
          this.$store.dispatch('SetLoading',false)
        });
      });
    },
    resetForm () {
      this.form = {
        id: 0,
        name: "",
        version: 0,
        category: 1,
        categoryNo: "",
        categoryNoCatalog: "",
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return RemoveMedicalInsuranceCategory({ ids });
        })
        .then(() => {
          this.$my_message(`删除成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query.keyWord = "";
      this.$set(this.query, "pageIndex", 1);
      this.$set(this.query, "pageSize", 10);
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
  },
  mounted () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>
